import { ModelBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class OTPRegistrationVerification extends ModelBase {

    public registrationId: number = 0;

    public otp: string = "";

}